







































































































































import { Component, Vue } from 'vue-property-decorator'
import { findTradingMerchantList, fundChangeList, fundChangeListExport } from '@/api/com'
import { formatDate } from '@/utils/tool'
import Nav from '../Business/pages/components/Navs.vue'

interface tokenData {
  expiresIn: number,
  refreshToken: string,
  token: string,
}

@Component({
  // 所有的组件选项都可以放在这里
  name: 'TradeDetail',
  components: {
    Nav
  }
})

export default class TradeDetail extends Vue {
  private navBarList = [{
    name: '商户中心',
    path: '/business/info'
  }]

  formatDate = formatDate

  currency = ''

  date:string[] = []

  form = {
    treeId: '', // 交易内容
    merchant: '',
    id: '',
    orderType: '' // 交易类型
  }

  // 交易内容
  treeIdSelects = [
    { label: '全部', value: '' },
    { label: '充值', value: 'T' },
    { label: '提现', value: 'W' }
    // { label: '支付', value: 'Pay' },
    // { label: '退款', value: 'Cancel' }
  ]

  // 交易类型
  orderTypeSelects = [
    { label: '全部', value: '' },
    { label: '串货商支付', value: '0' },
    { label: '串货商退款', value: '1' },
    { label: '被串货商收入', value: '2' },
    { label: '被串货商退款', value: '3' }
  ]

  merchantSelects: any[] = []

  loading = true

  formLoading = false

  tableData: any[] = []

  currentPage = 1

  resultNum = 10

  total = 0

  tokenData:tokenData = {
    expiresIn: 0,
    refreshToken: '',
    token: ''
  }

  get typeId () {
    const treeId = this.form.treeId
    const orderType = this.form.orderType
    if (treeId === '' && orderType === '') {
      return ''
    }
    if (treeId === '' && orderType === '0') {
      return 1
    }
    if (treeId === '' && orderType === '1') {
      return 0
    }
    if (treeId === '' && orderType === '2') {
      return 0
    }
    if (treeId === '' && orderType === '3') {
      return 1
    }

    if (treeId === 'T' && orderType === '') {
      return 0
    }

    if (treeId === 'W' && orderType === '') {
      return 1
    }

    return ''
  }

  // 切换当前页码
  handleCurrentChange (val: number): void {
    this.currentPage = val
    this.getTradeDetailList()
  }

  handleSizeChange (val: number):void {
    console.log(`每页 ${val} 条`)
  }

  // 获取交易商户列表
  getMerchantList (): void {
    const params = {
      currencyCode: this.currency,
      edate: this.date[1],
      mchId: this.$store.state.User.userInfo.parentMchId,
      sdate: this.date[0]
    }
    findTradingMerchantList(params).then((res: any) => {
      console.log(res, '获取交易商户列表')
      if (res && res.length > 0) this.merchantSelects = res
      this.merchantSelects.unshift({
        parentMchId: '',
        mchName: '全部'
      })
    })
  }

  // 选择日期
  handleChangeDate (value: string[]): void {
    console.log(value)
    this.getMerchantList()
  }

  // 获取交易明细列表
  getTradeDetailList (): void {
    this.loading = true
    // const typeId = this.form.content === 'Pay' ? 1 : this.form.content === 'Cancel' ? 0 : ''
    const params = {
      treeId: this.form.treeId,
      syncMchId: this.form.merchant,
      orderId: this.form.id,
      mchId: this.$store.state.User.userInfo.parentMchId,
      sdate: this.date[0],
      edate: this.date[1],
      currencyCode: this.currency,
      orderType: this.form.orderType,
      typeId: this.typeId,
      page: this.currentPage,
      resultNum: this.resultNum,
      autoCount: true
    }
    fundChangeList(params).then(res => {
      console.log(res, '获取交易明细列表')
      this.loading = false
      if (res) {
        this.tableData = res.results
        this.total = res.sizeAll
      }
    })
  }

  handleSearch (): void {
    this.currentPage = 0
    this.getTradeDetailList()
  }

  // 导出excel
  handleGetExcel () {
    this.formLoading = true
    // const typeId = this.form.content === 'Pay' ? 1 : this.form.content === 'Cancel' ? 0 : ''
    const params = {
      treeId: this.form.treeId,
      syncMchId: this.form.merchant,
      orderId: this.form.id,
      mchId: this.$store.state.User.userInfo.parentMchId,
      sdate: this.date[0],
      edate: this.date[1],
      currencyCode: this.currency,
      orderType: this.form.orderType,
      typeId: this.typeId,
      page: this.currentPage,
      resultNum: this.resultNum,
      autoCount: true
    }
    fundChangeListExport(params).then(res => {
      this.formLoading = false
      console.log(res)
      const blob = new Blob([res], { type: 'application/octet-stream' })
      const blobUrl = window.URL.createObjectURL(blob)
      const fileName = '交易明细列表_' + this.date[1] + '.xls'
      const a = document.createElement('a')
      a.style.display = 'none'
      a.download = fileName // 文件名
      a.href = blobUrl
      a.click()
    }).catch(() => {
      this.formLoading = false
    })
  }

  mounted (): void {
    const { currency } = this.$route.query
    if (typeof currency !== 'undefined') {
      this.currency = currency.toString()
    }
    const now = new Date().getTime()
    const defaultEdate = formatDate(now, 'Y-M-D')
    const time = 6 * 24 * 60 * 60 * 1000
    const defaultSdate = formatDate(now - time, 'Y-M-D')
    this.date = [defaultSdate, defaultEdate]
    this.getMerchantList()
    this.getTradeDetailList()
  }
}

